import { useRouter } from "next/router";

import { translate } from "@ascendnow/shared";

import AscHeading from "../AscTypography/AscHeading/AscHeading";
import AscSelectInput from "../AscInputFields/AscSelectInput/AscSelectInput";
import { baselineAssessmentColor } from "./AscBaselineAssessmentComparison.helper";
import { AscBaselineAssessmentComparisonHeaderProps } from "./AscBaselineAssessmentComparison.type";
import styles from "./AscBaselineAssessmentComparison.module.scss";

export function AscBaselineAssessmentComparisonHeader({
  title,
  subtitle,
  categoryAttempts,
  categories,
}: AscBaselineAssessmentComparisonHeaderProps) {
  const router = useRouter();

  const handleSelectCategory = (value: string, key: string) => {
    router.replace(
      { pathname: router.pathname, query: { ...router.query, [key]: value } },
      undefined,
      {
        shallow: true,
      }
    );
  };

  const existingStats =
    categories && categories.length > 0
      ? categories.filter((el) => el?.visibleInStatistics)
      : [];

  const batchStats = existingStats.find((el) => el.key === "batch");
  const groupStats = existingStats.find((el) => el.key === "group");
  const schoolStats = existingStats.find((el) => el.key === "school");
  const globalStats = existingStats.find((el) => el.key === "global");

  return (
    <header className={styles.header}>
      <div className={styles.headerTop}>
        <div className={styles.headerTopLeft}>
          <AscHeading className={styles.title} level={4}>
            {title}
          </AscHeading>
          {subtitle && <span className={styles.subtitle}>{subtitle}</span>}
        </div>
        {categories && (
          <div className={styles.headerTopRight}>
            <span className={styles.completedStudentsTitle}>
              {translate("baselineComparisonCompletedStudents")}
            </span>
            <div className={styles.completedStudentsWrapper}>
              {groupStats && (
                <div className={styles.completedStudents}>
                  <span className={styles.label}>{translate("group")}</span>
                  <span className={styles.value}>
                    {groupStats?.count}/{groupStats?.overallCount}
                  </span>
                </div>
              )}
              {batchStats && (
                <div className={styles.completedStudents}>
                  <span className={styles.label}>{translate("batch")}</span>
                  <span className={styles.value}>
                    {batchStats?.count}/{batchStats?.overallCount}
                  </span>
                </div>
              )}
              {schoolStats && (
                <div className={styles.completedStudents}>
                  <span className={styles.label}>{translate("school")}</span>
                  <span className={styles.value}>
                    {schoolStats?.count}/{schoolStats?.overallCount}
                  </span>
                </div>
              )}
              {globalStats && (
                <div className={styles.completedStudents}>
                  <span className={styles.label}>{translate("global")}</span>
                  <span className={styles.value}>
                    {globalStats?.count}/{globalStats?.overallCount}
                  </span>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
      {categoryAttempts && categoryAttempts.length > 0 && (
        <div className={styles.headerBottom}>
          <div className={styles.category}>
            <span
              className={styles.categoryColor}
              style={{
                background: baselineAssessmentColor.blue,
              }}
            />
            <AscSelectInput
              multiple={false}
              showArrowIcon
              className={styles.categorySelect}
              value={router.query.bAttempt1 || categoryAttempts[0].value}
              onChange={(e) => handleSelectCategory(e as string, "bAttempt1")}
            >
              {categoryAttempts.slice(0, 3).map((c) => (
                <AscSelectInput.Option
                  key={c.value}
                  value={c.value}
                  label={c.label}
                />
              ))}
            </AscSelectInput>
          </div>
          <div className={styles.category}>
            <span
              className={styles.categoryColor}
              style={{
                background: baselineAssessmentColor.violet,
              }}
            />
            <AscSelectInput
              multiple={false}
              showArrowIcon
              className={styles.categorySelect}
              value={router.query.bAttempt2 || categoryAttempts[3].value}
              onChange={(e) => handleSelectCategory(e as string, "bAttempt2")}
            >
              {categoryAttempts.slice(3, 6).map((c) => (
                <AscSelectInput.Option
                  key={c.value}
                  value={c.value}
                  label={c.label}
                />
              ))}
            </AscSelectInput>
          </div>
          <div className={styles.category}>
            <span
              className={styles.categoryColor}
              style={{
                background: baselineAssessmentColor.gold,
              }}
            />
            <AscSelectInput
              multiple={false}
              showArrowIcon
              className={styles.categorySelect}
              value={router.query.bAttempt3 || categoryAttempts[6].value}
              onChange={(e) => handleSelectCategory(e as string, "bAttempt3")}
            >
              {categoryAttempts.slice(6).map((c) => (
                <AscSelectInput.Option
                  key={c.value}
                  value={c.value}
                  label={c.label}
                />
              ))}
            </AscSelectInput>
          </div>
        </div>
      )}
    </header>
  );
}
